// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-created-by-cell .fi-wrapper-table-span-cell:not(:last-of-type) {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-created-by-cell/fi-wrapper-table-created-by-cell.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR","sourcesContent":[".fi-wrapper-table-created-by-cell {\r\n    .fi-wrapper-table-span-cell:not(:last-of-type) {\r\n        margin-right: 5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
